import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { EndPoints } from 'src/@shared/shared/enum';

@Injectable({
  providedIn: 'root',
})
export class PartyDomainService {
  constructor(private commonService: CommonService) {}

  getAllAddedVendors(siteId: any, page: any, pageSize: any, sortBy: any, sortField: any) {
    return this.commonService.API_GET(
      EndPoints.GetAllAddedVendors +
        `?siteId=${siteId}&startPosition=${page}&pageSize=${pageSize}&sortOrder=${sortBy}&sortField=${sortField}`,
      false
    );
  }

  deleteVendor(vendorId: any) {
    return this.commonService.API_DELETE(EndPoints.DeleteVendor + `/${vendorId}`);
  }

  searchInDatabase(searchText: any, siteId: any) {
    return this.commonService.API_GET(
      EndPoints.GetDBVendors + `?searchText=${searchText}&siteId=${siteId}`,
      false
    );
  }

  editVendor(requestBody: any) {
    const hd = this.commonService.GetAuthorizationHeader();
    return this.commonService.API_POST(EndPoints.EditVendor, requestBody, false, {
      headers: hd,
    });
  }

  addVendorFromDB(formdata: any) {
    const hd = this.commonService.GetAuthorizationHeader();
    return this.commonService.API_POST(EndPoints.AddVendorFromDB, formdata, false, {
      headers: hd,
    });
  }

  getAllAddedInvestors(requestBody: any) {
    return this.commonService.API_POST(EndPoints.GetAllAddedInvestors, requestBody, false);
  }

  deleteInvestor(investorId: any) {
    return this.commonService.API_DELETE(EndPoints.DeleteInvestor + `/${investorId}`);
  }

  exportInvestorsToExcel(body: any) {
    const hd = this.commonService.GetAuthorizationHeader();
    return this.commonService.API_POST(EndPoints.ExportInvestors, body, false, {
      responseType: 'blob',
      headers: hd,
    });
  }

  exportVendorsToExcel(siteId: string) {
    const hd = this.commonService.GetAuthorizationHeader();
    return this.commonService.API_GET(EndPoints.ExportVendors + `?siteId=${siteId}`, false, {
      responseType: 'blob',
      headers: hd,
    });
  }

  searchInDatabaseInvestor(searchText: any, siteId: any) {
    return this.commonService.API_GET(
      EndPoints.GetDBInvestors + `?searchText=${searchText}&siteId=${siteId}`,
      false
    );
  }

  addInvestorFromDB(formdata: any) {
    const hd = this.commonService.GetAuthorizationHeader();
    return this.commonService.API_POST(EndPoints.AddInvestorFromDB, formdata, false, {
      headers: hd,
    });
  }

  getInvestorsForDropdown(siteId: any, searchText: string) {
    return this.commonService.API_GET(
      EndPoints.GetInvestorsBySite + `?SiteId=${siteId}&searchText=${searchText}`,
      false
    );
  }

  getInvestorDetails(investorId: any) {
    return this.commonService.API_GET(EndPoints.GetInvestorDetails + `?InvestorId=${investorId}`, false);
  }

  getSiteNonAlcBalance(siteId: any) {
    return this.commonService.API_GET(EndPoints.GetSiteNonAlcBalance + `?siteId=${siteId}`, false);
  }
}
